import { render, staticRenderFns } from "./nationalities.vue?vue&type=template&id=62687004"
import script from "./nationalities.vue?vue&type=script&lang=js"
export * from "./nationalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports